<template>
  <v-card>
    <v-card-title class="bg-indigo text-white d-flex justify-space-between align-center">
      <div>
        <v-icon start>mdi-shield-account</v-icon>
        Gestión de Administradores
      </div>
      <v-btn color="white" variant="text" @click="openAddDialog">
        <v-icon start>mdi-account-plus</v-icon>
        Agregar Administrador
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="admins"
        :loading="loading"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:no-data>
          <v-alert type="info" border="start" color="indigo" variant="tonal">
            No hay administradores registrados actualmente.
          </v-alert>
        </template>

        <template v-slot:item.vigente="{ item }">
          <v-btn
            size="x-small"
            :color="item.vigente === 1 ? 'green' : 'red'"
            :text="item.vigente === 1 ? 'Vigente': 'No Vigente'"
          ></v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            icon="mdi-pencil"
            size="small"
            color="blue"
            variant="text"
            title="Editar Administrador"
            @click="openEditDialog(item)"
          />
          <v-btn
            icon="mdi-lock-outline"
            size="small"
            color="blue"
            variant="text"
            title="Editar Contraseña"
            @click="openEditPassword(item)"
          />
          <v-btn
            :icon="item.vigente === 1 ? 'mdi-check-circle' : 'mdi-close-thick'"
            size="small"
            :color="item.vigente === 1 ? 'green' : 'red'"
            variant="text"
            title="Actualizar Vigencia"
            @click="actualizarVigencia(item)"
          />
          <v-btn
            icon="mdi-delete"
            size="small"
            color="red"
            variant="text"
            title="Eliminar Administrador"
            @click="confirmDelete(item)"
          />
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Back to Panel -->
    <div class="text-center mt-6 mb-6">
      <v-btn
        to="/admin"
        variant="text"
        color="grey-darken-1"
        prepend-icon="mdi-arrow-left"
      >
        Volver al Panel
      </v-btn>
    </div>

    <!-- Add Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="bg-orange text-white">
          <span class="text-h5">Agregar Administrador</span>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formData.cuit"
              label="CUIT"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <v-text-field
              v-model="formData.mail"
              label="Email"
              :rules="[rules.email]"
              variant="outlined"
              class="mb-4"
            />

            <v-text-field
              v-model="formData.password"
              label="Contraseña"
              type="password"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <!-- Rol fijo -->
            <v-text-field
              v-model="rolFijo"
              label="Rol"
              variant="outlined"
              readonly
              hide-details
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="closeDialog">
            Cancelar
          </v-btn>
          <v-btn color="indigo" variant="flat" @click="saveAdmin" :disabled="!valid">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog-->
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title class="bg-orange text-white">
          <span class="text-h5">Editar Cliente</span>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formData.cuit"
              label="CUIT"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <v-text-field
              v-model="formData.mail"
              label="Email"
              :rules="[rules.email]"
              variant="outlined"
              class="mb-4"
            />

            <!-- Rol fijo oculto -->
            <v-text-field
              v-model="rolFijo"
              label="Rol"
              variant="outlined"
              readonly
              hide-details
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="closeEditDialog">
            Cancelar
          </v-btn>
          <v-btn color="indigo" variant="flat" @click="UpdateClient" :disabled="!valid">
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Pass Dialog-->
    <v-dialog v-model="passDialog" max-width="600px">
      <v-card>
        <v-card-title class="bg-orange text-white">
          <span class="text-h5">Editar Contraseña Cliente</span>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formPass.password"
              label="Contraseña Actual"
              variant="outlined"
              class="mb-4"
              readonly
            />

            <v-text-field
              v-model="formPass.newPass"
              label="Nueva Contraseña"
              :rules="[rules.required]"
              variant="outlined"
              class="mb-4"
            />

            <!-- Rol fijo oculto -->
            <v-text-field
              v-model="rolFijo"
              label="Rol"
              variant="outlined"
              readonly
              hide-details
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="closePassDialog">
            Cancelar
          </v-btn>
          <v-btn color="indigo" variant="flat" @click="UpdatePassClient" :disabled="!valid">
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h5">Confirmar Eliminación</v-card-title>
        <v-card-text>
          ¿Está seguro que desea eliminar este administrador?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="deleteDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="red" variant="flat" @click="deleteAdmin">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const headers = [
  { title: 'ID', key: 'id_usuario', sortable: true },
  { title: 'CUIT', key: 'cuit', sortable: true },
  { title: 'Email', key: 'mail', sortable: true },
  { title: 'Contraseña', key: 'password', sortable: false },
  { title: 'Estado', key: 'vigente', sortable: false },
  { title: 'Acciones', key: 'actions', sortable: false, align: 'center' }
]

const admins = ref([])
const loading = ref(false)
const dialog = ref(false)
const editDialog = ref(false)
const deleteDialog = ref(false)
const passDialog = ref(false)
const valid = ref(false)
const rolFijo = ref('Administrador')

const formData = ref({
  id_usuario: null,
  cuit: '',
  mail: '',
  password: '',
  id_role: 1 // 👈 siempre ADMIN
})

const formPass = ref({
  id_usuario: null,
  password: '',
  newPass: '',
  id_role: 1
})

const rules = {
  required: value => !!value || 'Campo requerido',
  email: value => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return !value || pattern.test(value) || 'Email inválido'
  }
}

const selectedAdmin = ref(null)

// 🚀 Llamado al Vuex
const fetchAdmins = async () => {
  loading.value = true
  const result = await store.dispatch("user/fetchAdmins")
  if (result?.success) {
    // Filtra solo los de rol ADMIN
    const allUsers = store.getters["user/getAllAdmins"]
    admins.value = allUsers.filter(u => u.id_role === 1)
  } else {
    console.error("Error al obtener administradores:", result?.message)
  }
  loading.value = false
}

const openAddDialog = () => {
  formData.value = {
    id_usuario: null,
    cuit: '',
    mail: '',
    password: '',
    id_role: 1 // 👈 admin fijo
  }
  dialog.value = true
}

const openEditDialog = (admin) => {
  formData.value = {
    id_usuario: admin.id_usuario,
    cuit: admin.cuit,
    mail: admin.mail,
    password: '',
    id_role: 1 // 👈 admin fijo
  }
  editDialog.value = true
}

const openEditPassword = (admin) => {
  formPass.value = {
    id_usuario: admin.id_usuario,
    password: admin.password,
    newPass: '',
    id_role: 2
  }
  passDialog.value = true
}

const closeDialog = () => {
  dialog.value = false
  formData.value = {
    id_usuario: null,
    cuit: '',
    mail: '',
    password: '',
    id_role: 1
  }
}

const closeEditDialog = () => {
  editDialog.value = false
  formData.value = {
    id_usuario: null,
    cuit: '',
    mail: '',
    password: '',
    id_role: 1
  }
}

const closePassDialog = () => {
  passDialog.value = false
  formPass.value = {
    id_usuario: null,
    password: '',
    newPass: '',
    id_role: 1
  }
}

const saveAdmin = async () => {
  if (!valid.value) return
  loading.value = true
  const action = "addClient"
  const result = await store.dispatch(`user/${action}`, formData.value)
  if (result.success) {
    await fetchAdmins()
    dialog.value = false
  } else {
    alert(result.message || "Error al guardar el administrador")
  }
  loading.value = false
}

const UpdateClient = async () => {
  if (!valid.value) return
  loading.value = true
  const action = "updateAdmin"
  const result = await store.dispatch(`user/${action}`, formData.value)
  if (result.success) {
    await fetchAdmins()
    editDialog.value = false
  } else {
    alert(result.message || "Error al guardar los cambios")
  }
  loading.value = false
}

const UpdatePassClient = async () => {
  if (!valid.value) return
  loading.value = true
  const action = "passAdmin"
  const result = await store.dispatch(`user/${action}`, formPass.value)
  if (result.success) {
    await fetchAdmins()
    passDialog.value = false
  } else {
    alert(result.message || "Error al guardar los cambios")
  }
  loading.value = false
}

const actualizarVigencia = async (admin) => {
  const nuevoEstado = admin.vigente === 1 ? 0 : 1
  const result = await store.dispatch("user/toggleClientVigencia", {
    id_usuario: admin.id_usuario,
    vigente: nuevoEstado
  })
  
  if (result.success) {
    await fetchAdmins()
  } else {
    alert(result.message || "Error al actualizar estado del administrador")
  }
}

const confirmDelete = (admin) => {
  selectedAdmin.value = admin
  deleteDialog.value = true
}

const deleteAdmin = async () => {
  loading.value = true
  const result = await store.dispatch("user/deleteClient", selectedAdmin.value.id_usuario)
  if (result.success) {
    await fetchAdmins()
    deleteDialog.value = false
  } else {
    alert(result.message || "Error al eliminar el administrador")
  }
  loading.value = false
}

onMounted(() => {
  fetchAdmins()
})
</script>